<template>
  <hic-dialog :title="!value.id ? '应用新增' : '应用编辑'" :visible="visible" width="80%" @open="openEditor" @close="cancel" :close-on-click-modal="false">
    <el-form style="padding: 30px 60px 30px 0px" label-position="right" :inline="false" ref="editor" label-width="130px" :rules="comRules" :model="value">
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input type="text" placeholder="请输入应用名称" v-model.trim="value.name"></el-input>
          </el-form-item>
          <el-form-item label="编码" prop="code">
            <el-input type="text" placeholder="请输入编码" v-model.trim="value.code" :disabled="!!value.id" />
          </el-form-item>
          <el-form-item label="授权模式" prop="loginMode">
            <el-select multiple v-model="value.loginModes" placeholder="请选择" style="width: 100%">
              <el-option :key="item" v-for="item in ['authorization_code', 'refresh_token']" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="安全码" prop="securityCode">
            <el-input type="password" placeholder="请输入安全码" v-model.trim="value.securityCode" />
          </el-form-item>
          <el-form-item label="图标" :span="12">
            <el-input type="text" placeholder="请输入" v-model.trim="value.logoUri" />
          </el-form-item>
          <el-image v-if="value.logoUri" :src="$cfg.oauth.server + '/' + value.logoUri" style="width: 80px; height: 80px" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="首页地址">
            <el-input type="text" placeholder="请输入" v-model.trim="value.homeUrl" />
          </el-form-item>
          <el-form-item label="回调地址" prop="callbackAAddress">
            <el-input type="text" placeholder="请输入回调地址" v-model.trim="value.callbackAAddress" />
          </el-form-item>
          <el-form-item label="token有效期" prop="validity">
            <el-input type="number" placeholder="请输入有效期" v-model.trim="value.validity" />
          </el-form-item>
          <el-form-item label="刷新token有效期" prop="refreshValidity">
            <el-input type="number" placeholder="请输入刷新token有效期" v-model.trim="value.refreshValidity" />
          </el-form-item>
          <el-form-item label="排序" prop="remark">
            <el-input type="number" placeholder="请输入" v-model.trim="value.seq" />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" placeholder="请输入" :rows="3" v-model.trim="value.remark" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权限JSON">
            <el-input type="textarea" placeholder="请输入" v-model.trim="value.permissions" rows="10" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :loading="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  export default {
    props: {
      value: {},
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        comRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" },
            { max: 128, message: "名称长度在 128 个字符以内", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入编码", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
          ],
          securityCode: [
            { required: true, message: "请输入编码", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
          ],
          loginMode: [{ required: true, message: "请输入编码", trigger: "blur" }],
          callbackAAddress: [{ required: true, message: "请输入回调地址", trigger: "blur" }],
          validity: [{ required: true, message: "请输入有效期", trigger: "blur" }],
          refreshValidity: [
            {
              required: true,
              message: "请正确输入刷新token有效期",
              trigger: "blur",
            },
          ],
          autoBypass: [{ required: true, message: "请输入编码", trigger: "blur" }],
        },
        disabledSave: false,
      };
    },
    methods: {
      openEditor() {
        this.disabledSave = false;
        if (this.$refs.editor) {
          this.$refs.editor.clearValidate();
        }
        if (this.value.id) {
          this.value.securityCode = null;
          this.comRules.securityCode[0].required = false;
          this.value.loginModes = this.value.loginMode.split(",");
        } else {
          this.comRules.securityCode[0].required = true;
        }
      },
      save() {
        let _this = this;
        // if (!this.value.id) {
        //   this.comRules.securityCode[0].required = true
        // } else{
        //   this.comRules.securityCode[0].required = false
        // }
        this.$refs.editor.validate((valid) => {
          try {
            JSON.parse(this.value.permissions);
          } catch (err) {
            this.$message.error(`权限JSON字符串存在问题：${err}`);
            return;
          }
          if (valid) {
            this.disabledSave = true;
            if (this.value.loginModes) {
              this.value.loginMode = this.value.loginModes.join(",");
            }
            api
              .Apply.save(this.value)
              .then((res) => {
                _this.$message.success("保存成功!");
                _this.$store.dispatch("loadDicts", "Sys");
                _this.$emit("update:visible", false);
                _this.$emit("ok");
              })
              .catch((err) => {
                if (err) {
                  _this.$message.error(err.message || err);
                }
              })
              .finally(() => {
                _this.disabledSave = false;
              });
          }
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
    },
  };
</script>
